module.exports = __webpack_public_path__ + "static/media/SOC.27e441e2.png";